import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid';

const SettleMatchComponent = ({
    matchData: propMatchData,
    onDataChange,
    initialGames,
    initialPlayerStats,
    isEditing = false
}) => {
    const { id, date } = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [team1Info, setTeam1Info] = useState(null);
    const [team2Info, setTeam2Info] = useState(null);
    const [team1Players, setTeam1Players] = useState([]);
    const [team2Players, setTeam2Players] = useState([]);
    const [activeGameTab, setActiveGameTab] = useState(1);

    console.log("initialPlayerStats", initialPlayerStats);

    const [games, setGames] = useState(initialGames);
    const [playerStats, setPlayerStats] = useState(initialPlayerStats);

    useEffect(() => {
        if (onDataChange && !loading) {
            onDataChange({
                games,
                playerStats,
                team1Players,
                team2Players,
                team1Info,
                team2Info
            });
        }
    }, [games, playerStats, onDataChange, loading, team1Players, team2Players, team1Info, team2Info]);

    useEffect(() => {
        const fetchMatch = async () => {
            try {
                setLoading(true);
                let currentMatchData;

                if (propMatchData) {
                    console.log("Using provided match data", propMatchData);
                    currentMatchData = propMatchData;
                } else if (location.state?.matchData) {
                    console.log("Using passed match data", location.state.matchData);
                    currentMatchData = location.state.matchData;
                }

                const teamsData = currentMatchData.teams;

                const team1 = teamsData.find(t => t.designation === 1);
                if (team1) {
                    setTeam1Info({
                        id: team1.id,
                        name: team1.name,
                        image: team1.image
                    });
                    setTeam1Players(team1.players || []);
                }

                const team2 = teamsData.find(t => t.designation === 2);
                if (team2) {
                    setTeam2Info({
                        id: team2.id,
                        name: team2.name,
                        image: team2.image
                    });
                    setTeam2Players(team2.players || []);
                }

                //if (currentMatchData.games && currentMatchData.games.length > 0) {
                //    setGames(currentMatchData.games.map((game, index) => ({
                //        game_number: index + 1,
                //        duration: game.duration || 300,
                //        map_name: game.map || 'DFH Stadium',
                //        blue_team_score: game.team1score || 0,
                //        orange_team_score: game.team2score || 0,
                //        winner: game.winner === 1 ? 'team1' :
                //            game.winner === 2 ? 'team2' : null
                //    })));
                //}

                //if (currentMatchData.playerStats) {
                //    setPlayerStats(currentMatchData.playerStats);
                //} else {
                //    initializePlayerStats([team1, team2]);
                //}

                setLoading(false);
            } catch (error) {
                console.error('Error fetching match:', error);
                setLoading(false);
            } finally {
                setLoading(false);
            }
        };

        fetchMatch();
    }, [id, date, propMatchData]);

    const addGame = () => {
        const newGameNumber = games.length + 1;

        // Add new game
        setGames([
            ...games,
            {
                game_number: newGameNumber,
                duration: 300,
                map_name: 'DFH Stadium',
                blue_team_score: 0,
                orange_team_score: 0,
                winner: null
            }
        ]);

        // Create a deep copy of the current player stats
        const updatedPlayerStats = JSON.parse(JSON.stringify(playerStats));

        // Initialize stats for the new game for all players
        team1Players.forEach(player => {
            const playerId = player.id;
            const key = `${team1Info.id}-${playerId}`;
            // Make sure this player has an entry in the stats object
            if (!updatedPlayerStats[key]) {
                updatedPlayerStats[key] = {};
            }

            // Add stats for the new game number
            updatedPlayerStats[key][newGameNumber] = {
                score: null,
                goals: null,
                assists: null,
                saves: null,
                shots: null,
                total_distance: null
            };
        });

        team2Players.forEach(player => {
            const playerId = player.id;
            const key = `${team2Info.id}-${playerId}`;
            // Make sure this player has an entry in the stats object
            if (!updatedPlayerStats[key]) {
                updatedPlayerStats[key] = {};
            }

            // Add stats for the new game number
            updatedPlayerStats[key][newGameNumber] = {
                score: null,
                goals: null,
                assists: null,
                saves: null,
                shots: null,
                total_distance: null
            };
        });


        // Update the player stats state with the new structure
        setPlayerStats(updatedPlayerStats);
        setActiveGameTab(newGameNumber);
    };

    const removeGame = (gameNumber) => {
        if (games.length <= 1) return;

        const filteredGames = games.filter(game => game.game_number !== gameNumber);

        const renumberedGames = filteredGames.map((game, index) => ({
            ...game,
            game_number: index + 1
        }));

        setGames(renumberedGames);

        const updatedPlayerStats = {};

        Object.keys(playerStats).forEach(key => {
            updatedPlayerStats[key] = {};

            let newGameNumber = 1;

            for (let i = 1; i <= games.length; i++) {
                if (i === gameNumber) continue;

                if (playerStats[key][i]) {
                    updatedPlayerStats[key][newGameNumber] = playerStats[key][i];
                    newGameNumber++;
                }
            }
        });

        setPlayerStats(updatedPlayerStats);

        if (activeGameTab === gameNumber) {
            setActiveGameTab(1);
        } else if (activeGameTab > gameNumber) {
            setActiveGameTab(activeGameTab - 1);
        }
    };

    const handleGameInputChange = (gameNumber, field, value) => {
        let processedValue;
        if (field === 'winner') {
            processedValue = value;
        } else if (field === 'map_name') {
            processedValue = value;
        } else {
            processedValue = value === '' ? 0 : parseInt(value);
        }

        setGames(games.map(game =>
            game.game_number === gameNumber
                ? { ...game, [field]: processedValue }
                : game
        ));
    };

    const handlePlayerStatChange = (teamId, playerId, gameNumber, stat, value) => {
        // Convert empty string to null, indicating no data entered
        let parsedValue = value;
        if (value === '' || value === null || value === undefined) {
            parsedValue = null;
        } else if (typeof value === 'string') {
            parsedValue = parseInt(value);
        }

        const key = `${teamId}-${playerId}`;
        setPlayerStats(prevStats => ({
            ...prevStats,
            [key]: {
                ...prevStats[key],
                [gameNumber]: {
                    ...prevStats[key]?.[gameNumber],
                    [stat]: parsedValue
                }
            }
        }));
    };

    if (loading) {
        return <div className="loading-spinner"></div>;
    }

    return (
        <div className="form-section">
            <h2>Game Details</h2>

            <div className="game-tabs">
                {games.map(game => (
                    <button
                        key={game.game_number}
                        type="button"
                        className={`game-tab ${activeGameTab === game.game_number ? 'active' : ''}`}
                        onClick={() => setActiveGameTab(game.game_number)}
                    >
                        Game {game.game_number}
                    </button>
                ))}

                <button
                    type="button"
                    className="add-game-button"
                    onClick={addGame}
                >
                    + Add Game
                </button>
            </div>

            {games.map(game => (
                <div
                    key={game.game_number}
                    className={`game-panel ${activeGameTab === game.game_number ? 'active' : ''}`}
                >
                    <div className="game-header">
                        <h3>Game {game.game_number}</h3>

                        <button
                            type="button"
                            className="remove-game-button"
                            onClick={() => removeGame(game.game_number)}
                            disabled={games.length <= 1}
                        >
                            Remove Game
                        </button>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Map</label>
                            <select
                                value={game.map_name}
                                onChange={(e) => handleGameInputChange(game.game_number, 'map_name', e.target.value)}
                            >
                                <option value="DFH Stadium">DFH Stadium</option>
                                <option value="Mannfield">Mannfield</option>
                                <option value="Champions Field">Champions Field</option>
                                <option value="Neo Tokyo">Neo Tokyo</option>
                                <option value="Wasteland">Wasteland</option>
                                <option value="Urban Central">Urban Central</option>
                                <option value="Beckwith Park">Beckwith Park</option>
                                <option value="Utopia Coliseum">Utopia Coliseum</option>
                                <option value="Forbidden Temple">Forbidden Temple</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label>Duration (seconds)</label>
                            <input
                                type="number"
                                min="0"
                                value={game.duration || ''}
                                onChange={(e) => handleGameInputChange(game.game_number, 'duration', e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="winner-selection">
                        <label>Winner</label>
                        <div className="winner-buttons">
                            <button
                                type="button"
                                className={`winner-button ${game.winner === 'team1' ? 'selected' : ''}`}
                                onClick={() => handleGameInputChange(game.game_number, 'winner', 'team1')}
                            >
                                {team1Info?.name || 'Team 1'}
                            </button>

                            <button
                                type="button"
                                className={`winner-button ${game.winner === 'team2' ? 'selected' : ''}`}
                                onClick={() => handleGameInputChange(game.game_number, 'winner', 'team2')}
                            >
                                {team2Info?.name || 'Team 2'}
                            </button>
                        </div>
                    </div>

                    <h4>Player Statistics</h4>

                    <div className="player-stats-section">
                        <div className="team-stats">
                            <h5>{team1Info?.name || 'Team 1'} Players</h5>

                            <table className="stats-table">
                                <thead>
                                    <tr>
                                        <th>Player</th>
                                        <th>Score</th>
                                        <th>Goals</th>
                                        <th>Assists</th>
                                        <th>Saves</th>
                                        <th>Shots</th>
                                        <th>Total Distance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {team1Players.map(player => (
                                        <tr key={`${team1Info?.id}-${player.id}`}>
                                            <td>{player.username || player.name}</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={playerStats[`${team1Info?.id}-${player.id}`]?.[game.game_number]?.score ?? ''}
                                                    onChange={(e) => handlePlayerStatChange(
                                                        team1Info.id,
                                                        player.id,
                                                        game.game_number,
                                                        'score',
                                                        e.target.value
                                                    )}
                                                    placeholder="0"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={playerStats[`${team1Info?.id}-${player.id}`]?.[game.game_number]?.goals ?? ''}
                                                    onChange={(e) => handlePlayerStatChange(
                                                        team1Info.id,
                                                        player.id,
                                                        game.game_number,
                                                        'goals',
                                                        e.target.value
                                                    )}
                                                    placeholder="0"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={playerStats[`${team1Info?.id}-${player.id}`]?.[game.game_number]?.assists ?? ''}
                                                    onChange={(e) => handlePlayerStatChange(
                                                        team1Info.id,
                                                        player.id,
                                                        game.game_number,
                                                        'assists',
                                                        e.target.value
                                                    )}
                                                    placeholder="0"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={playerStats[`${team1Info?.id}-${player.id}`]?.[game.game_number]?.saves ?? ''}
                                                    onChange={(e) => handlePlayerStatChange(
                                                        team1Info.id,
                                                        player.id,
                                                        game.game_number,
                                                        'saves',
                                                        e.target.value
                                                    )}
                                                    placeholder="0"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={playerStats[`${team1Info?.id}-${player.id}`]?.[game.game_number]?.shots ?? ''}
                                                    onChange={(e) => handlePlayerStatChange(
                                                        team1Info.id,
                                                        player.id,
                                                        game.game_number,
                                                        'shots',
                                                        e.target.value
                                                    )}
                                                    placeholder="0"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={playerStats[`${team1Info?.id}-${player.id}`]?.[game.game_number]?.total_distance ?? ''}
                                                    onChange={(e) => handlePlayerStatChange(
                                                        team1Info.id,
                                                        player.id,
                                                        game.game_number,
                                                        'total_distance',
                                                        e.target.value
                                                    )}
                                                    placeholder="0"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="team-stats">
                            <h5>{team2Info?.name || 'Team 2'} Players</h5>

                            <table className="stats-table">
                                <thead>
                                    <tr>
                                        <th>Player</th>
                                        <th>Score</th>
                                        <th>Goals</th>
                                        <th>Assists</th>
                                        <th>Saves</th>
                                        <th>Shots</th>
                                        <th>Total Distance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {team2Players.map(player => (
                                        <tr key={`${team2Info?.id}-${player.id}`}>
                                            <td>{player.username || player.name}</td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={playerStats[`${team2Info?.id}-${player.id}`]?.[game.game_number]?.score ?? ''}
                                                    onChange={(e) => handlePlayerStatChange(
                                                        team2Info.id,
                                                        player.id,
                                                        game.game_number,
                                                        'score',
                                                        e.target.value
                                                    )}
                                                    placeholder="0"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={playerStats[`${team2Info?.id}-${player.id}`]?.[game.game_number]?.goals ?? ''}
                                                    onChange={(e) => handlePlayerStatChange(
                                                        team2Info.id,
                                                        player.id,
                                                        game.game_number,
                                                        'goals',
                                                        e.target.value
                                                    )}
                                                    placeholder="0"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={playerStats[`${team2Info?.id}-${player.id}`]?.[game.game_number]?.assists ?? ''}
                                                    onChange={(e) => handlePlayerStatChange(
                                                        team2Info.id,
                                                        player.id,
                                                        game.game_number,
                                                        'assists',
                                                        e.target.value
                                                    )}
                                                    placeholder="0"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={playerStats[`${team2Info?.id}-${player.id}`]?.[game.game_number]?.saves ?? ''}
                                                    onChange={(e) => handlePlayerStatChange(
                                                        team2Info.id,
                                                        player.id,
                                                        game.game_number,
                                                        'saves',
                                                        e.target.value
                                                    )}
                                                    placeholder="0"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={playerStats[`${team2Info?.id}-${player.id}`]?.[game.game_number]?.shots ?? ''}
                                                    onChange={(e) => handlePlayerStatChange(
                                                        team2Info.id,
                                                        player.id,
                                                        game.game_number,
                                                        'shots',
                                                        e.target.value
                                                    )}
                                                    placeholder="0"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    value={playerStats[`${team2Info?.id}-${player.id}`]?.[game.game_number]?.total_distance ?? ''}
                                                    onChange={(e) => handlePlayerStatChange(
                                                        team2Info.id,
                                                        player.id,
                                                        game.game_number,
                                                        'total_distance',
                                                        e.target.value
                                                    )}
                                                    placeholder="0"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export const formatGameDetailsForSubmission = (games, team1Players, team2Players, playerStats, team1Info, team2Info) => {
    const gameDetails = {};
    games.forEach(game => {
        const winnerValue = game.winner === 'team1' ? 1 :
            game.winner === 'team2' ? 2 : null;

        const team1PlayerStats = {};
        team1Players.forEach(player => {
            const username = player.username || player.name;
            const key = `${team1Info?.id}-${player.id}`;
            if (playerStats[key] && playerStats[key][game.game_number]) {
                team1PlayerStats[username] = playerStats[key][game.game_number];
            }
        });

        const team2PlayerStats = {};
        team2Players.forEach(player => {
            const username = player.username || player.name;
            const key = `${team2Info?.id}-${player.id}`;
            if (playerStats[key] && playerStats[key][game.game_number]) {
                team2PlayerStats[username] = playerStats[key][game.game_number];
            }
        });

        gameDetails[`game${game.game_number}`] = {
            duration: game.duration,
            map: game.map_name,
            winner: winnerValue,
            team1score: game.blue_team_score,
            team2score: game.orange_team_score,
            team1players: team1PlayerStats,
            team2players: team2PlayerStats
        };
    });

    return gameDetails;
};

export default SettleMatchComponent; 